import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyformatpipe', pure: true })
export class CurrencyFormatPipe implements PipeTransform {
  transform(
    value: number,
    currencySign: string = '€ ',
    decimalLength: number = 2,
    chunkDelimiter: string = '.',
    decimalDelimiter: string = ',',
    chunkLength: number = 3
  ): string {
    const result = '\\d(?=(\\d{' + chunkLength.toString() + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
    const precision = Math.max(0, Math.trunc(decimalLength));
    const num = value.toFixed(precision);

    return (
      currencySign +
      (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(
        new RegExp(result, 'g'),
        '$&' + chunkDelimiter
      )
    );
  }
}
